import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import JSelectUserByDepModal from "./modal/JSelectUserByDepModal";
export default {
  name: 'JSelectUserByDep',
  components: {
    JSelectUserByDepModal: JSelectUserByDepModal
  },
  props: {
    modalWidth: {
      type: Number,
      default: 1250,
      required: false
    },
    value: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      selectedDepUsers: ""
    };
  },
  mounted: function mounted() {
    this.selectedDepUsers = this.value;
  },
  watch: {
    value: function value(val) {
      this.selectedDepUsers = val;
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  methods: {
    //通过组织机构筛选选择用户
    onSearchDepUser: function onSearchDepUser() {
      this.$refs.selectModal.showModal();
      this.onSearchDepUserCallBack('');
    },
    onSearchDepUserCallBack: function onSearchDepUserCallBack(selectedDepUsers) {
      this.selectedDepUsers = selectedDepUsers;
      this.$emit("change", selectedDepUsers);
    }
  }
};